import React from 'react';
import { useLaunchDarkly } from '@/providers/launchdarkly-provider';
import { MaintenanceMode } from '@/components/maintenance-mode';
import { MainRoutes } from '@/routes/main-routes';
import { Notifications } from '@/components/notifications';
import { NewVersionBanner } from '@/components/new-version-banner';

export const AppWrapper: React.FC = () => {
  const { isMaintenanceMode, maintenanceMessage, isLoading } =
    useLaunchDarkly();

  let bypassMaintenance = false;
  try {
    bypassMaintenance = localStorage.getItem('bypass-maintenance') === 'true';
  } catch {
    bypassMaintenance = false;
  }

  // Don't show maintenance mode while flags are loading
  if (isMaintenanceMode && !isLoading && !bypassMaintenance) {
    return <MaintenanceMode message={maintenanceMessage} />;
  }

  return (
    <Notifications>
      <MainRoutes />
      <NewVersionBanner />
    </Notifications>
  );
};
